import { render, staticRenderFns, recyclableRender, components } from "./tn-grid-item.vue?vue&type=template&id=7ff1616e&scoped=true&"
var renderjs
import script from "./tn-grid-item.vue?vue&type=script&lang=js&"
export * from "./tn-grid-item.vue?vue&type=script&lang=js&"
import style0 from "./tn-grid-item.vue?vue&type=style&index=0&id=7ff1616e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../软件/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff1616e",
  null,
  false,
  components,
  renderjs
)

export default component.exports